module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan3-2-b6c15813248565eacb2ddf2feff33cb5.webp";